import { classNames } from '../utilities';

export const SmsIcon = ({
  fill = '#5bd2ad',
  id,
  className,
  onClick,
  isClickable = true,
}) => {
  return (
    <svg
      className={classNames(
        isClickable ? 'cursor-pointer' : '',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07819 7.64653C5.34305 7.64653 5.56486 7.56193 5.74361 7.39274C5.92235 7.22354 6.01172 7.01388 6.01172 6.76376C6.01172 6.51363 5.92213 6.30417 5.74294 6.13539C5.56377 5.9666 5.34175 5.8822 5.07688 5.8822C4.81201 5.8822 4.59021 5.9668 4.41146 6.136C4.23272 6.30519 4.14334 6.51485 4.14334 6.76497C4.14334 7.01511 4.23293 7.22456 4.4121 7.39334C4.59129 7.56214 4.81332 7.64653 5.07819 7.64653ZM9.06447 7.64653C9.32935 7.64653 9.55116 7.56193 9.72989 7.39274C9.90863 7.22354 9.998 7.01388 9.998 6.76376C9.998 6.51363 9.90842 6.30417 9.72925 6.13539C9.55007 5.9666 9.32805 5.8822 9.06318 5.8822C8.7983 5.8822 8.5765 5.9668 8.39777 6.136C8.21902 6.30519 8.12965 6.51485 8.12965 6.76497C8.12965 7.01511 8.21924 7.22456 8.39841 7.39334C8.57758 7.56214 8.7996 7.64653 9.06447 7.64653ZM12.8956 7.64653C13.1605 7.64653 13.3823 7.56193 13.5611 7.39274C13.7398 7.22354 13.8292 7.01388 13.8292 6.76376C13.8292 6.51363 13.7396 6.30417 13.5604 6.13539C13.3812 5.9666 13.1592 5.8822 12.8943 5.8822C12.6295 5.8822 12.4077 5.9668 12.2289 6.136C12.0502 6.30519 11.9608 6.51485 11.9608 6.76497C11.9608 7.01511 12.0504 7.22456 12.2296 7.39334C12.4088 7.56214 12.6308 7.64653 12.8956 7.64653ZM3.54594 13.6493L1.28926 15.7803C1.0506 16.0057 0.776066 16.0577 0.465649 15.9362C0.155216 15.8148 0 15.598 0 15.2858V1.43086C0 1.04443 0.149705 0.709348 0.449116 0.425617C0.748541 0.141873 1.10214 0 1.50991 0H16.4848C16.894 0 17.2488 0.141873 17.5493 0.425617C17.8498 0.709348 18 1.04443 18 1.43086V12.2234C18 12.6085 17.8498 12.9424 17.5493 13.2252C17.2488 13.5079 16.894 13.6493 16.4848 13.6493H3.54594ZM2.96973 12.2234H16.4848V1.43086H1.50991V13.7275L2.96973 12.2234Z"
        fill="#8BCB53"
      />
    </svg>
  );
};
